<template>
	<div class="page with-logo">
		<router-link class="logo" to="/"></router-link>
		<h1>
			Boost your events
		</h1>
		<p>
			Welcome to Boost Buttons from Ents24: The UK's biggest live guide,
			connecting millions of fans with shows and tours every month– from music
			to comedy, theatre to festivals and beyond.
		</p>
		<p>
			Boost Buttons now lets you promote single or multiple shows or entire tours
			to a targeted audience more likely to buy tickets, combining our award-nominated
			analytics with a team of live entertainment experts.
		</p>
		<p>
			Hundreds of promoters and event organisers have used Boost Buttons to
			promote over a thousand shows. For examples of how your promotion might appear,
			<router-link to="/examples">click here</router-link>
			– or click below to get started.
		</p>
		<template v-if="appState === AppState.ENABLED">
			<router-link class="start button large gradient sunset with-v-gap" to="search">Start Promotion</router-link>
			<div class="powered-by with-v-gap">
				<span>SECURE PAYMENT</span>
				<a href="https://stripe.com/gb" target="_blank">
					<img src="../../../assets/img/powered-by-stripe-light.svg" width="130"/>
				</a>
			</div>
		</template>
		<div v-else-if="appState === AppState.DISABLED">
			<p>Sorry, Boost Buttons is currently down for maintenance.</p>
			<p>Please try again later.</p>
		</div>
		<div v-else-if="appState === AppState.PROBLEM">
			<p>Sorry, Boost Buttons failed to load.</p>
			<p>Please try again later.</p>
		</div>
		<div class="loading" v-else></div>

		<TermsFooter/>
	</div>
</template>

<script>
	import { EventBus } from '../../event-bus';
	import { AppState } from '../../app-state';
	import TermsFooter from '../TermsFooter';

	export default {
		props: ['appState'],
		mounted () {
			EventBus.$emit('clear-promotion');
		},
		components: {
			TermsFooter
		},
		beforeCreate() {
			this.AppState = AppState;
		}
	}
</script>

<style lang="scss" scoped>
	@import '../../../assets/scss/var';

	.powered-by {
		span {
			display: block;
		}
	}
</style>
